import React, { useCallback } from 'react';
import SearchBarFilterSelection from '../../../elements/SearchBarFilterSelection/SearchBarFilterSelection';

export default function ExhibitorsFilterSelection(props) {
    const { event, tags, selectedTags } = props;

    const handleRemoveTag = useCallback((tag, option) => {
        app.store.dispatch(app.actions.exhibitors.removeFilterTagOption(event.id, tag, option.name));
    }, []);

    const handleClearFilter = useCallback(() => {
        app.store.dispatch(app.actions.exhibitors.clearFilter(event.id));
    }, []);

    return <SearchBarFilterSelection tags={tags} selectedTags={selectedTags} onRemoveTag={handleRemoveTag} onClearFilter={handleClearFilter} />;
}
